import { lazy } from "react";
import { withSuspense } from "../components/common/SuspenseWrapper.js";
import { EmptyComponent } from "../components/common/EmptyComponent.js";

export class LazyLoadUtils {
  /**
   * Creates a lazy-loaded component with error handling for missing modules
   * @param {Function} importFn - Dynamic import function that returns a Promise
   * @param {Object} options - Configuration options
   * @param {string} options.componentName - Name of the component for logging
   * @param {React.Component} options.fallback - Fallback component (default: EmptyComponent)
   * @returns {React.Component} Lazy component wrapped with Suspense
   */
  static lazyWithFallback = (
    importFn,
    { componentName = "Component", fallback = EmptyComponent } = {}
  ) => {
    const LazyComponent = lazy(async () => {
      try {
        const component = await importFn();
        return component;
      } catch (e) {
        console.warn(
          `Userarea: ${componentName}: warning: Component is not defined.`,
          e
        );
        return { default: fallback };
      }
    });

    const WrappedComponent = withSuspense(LazyComponent);

    // Add preload method that silently catches errors
    WrappedComponent.preload = () => {
      return importFn().catch(() => {});
    };

    return WrappedComponent;
  };
}
